"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutKind = void 0;
/**
 * Represents the Editing Layout variant.
 * - shared - shared layout
 * - final - final layout
 */
var LayoutKind;
(function (LayoutKind) {
    LayoutKind["Final"] = "final";
    LayoutKind["Shared"] = "shared";
})(LayoutKind = exports.LayoutKind || (exports.LayoutKind = {}));
